import axios, { microServices } from './axios'
import { loaders } from './../constants'

// // ********************API url *******************
const GET_INVOICE_LIST = '/invoice/list'
const SAVE_INVOICE = '/invoice'
const GET_PROGRESS_CLAIM_LIST = '/progress-claim/list'
const PROJECT_INVOICE_DOWNLOAD = '/invoice/download'
const PROJECT_PCB_DOWNLOAD = '/progress-claim/download'
const GET_Invoice_AND_PROGRESS_CLAIM_LIST = '/invoice/progress-claim/list'
const PROGRESS_CLAIM = '/progress-claim'
const GET_PROJECT_CUSTOMER = '/project/customer'
const RETENTION_LIST = '/invoice/retention-list'
const RETENTION_TOTAL = '/invoice/tenant-retention-total'


// // ************API call Functions starts here **************

export const getInvoiceList = async (projectId, startDate, endDate, allowedModules) => {
  return await axios('get', GET_INVOICE_LIST, {}, {
    loader: loaders.OVERLAY, server: microServices.DE_CORE,
    params: {
      ...(projectId ? { projectId } : {}),
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
      allowedModules
    }
  }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const saveInvoice = async (data) => {
  return await axios('post', `${SAVE_INVOICE}`, data, { successMessage: 'Invoice Created Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getProgressClaimList = async (query) => {
  return await axios('get', `${GET_PROGRESS_CLAIM_LIST}${query ? query : ''}`, {}, { server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const downloadProjectProgressBreakup = async (id, format, tempId) => {
  return await axios('get', PROJECT_PCB_DOWNLOAD, {}, {
    loader: loaders.OVERLAY, server: microServices.DE_CORE,
    params: {
      ...(id ? { id } : {}),
      ...(tempId ? { tempId } : {}),
      ...(format ? { format } : {}),
    },
    responseType: 'blob'
  }).then(({ file, headers = {} }) => {
    const url = window.URL.createObjectURL(new Blob([file]));
    const link = document.createElement('a');
    link.href = url;
    const contentDisposition = headers["content-disposition"];
    link.download = contentDisposition && contentDisposition.split("filename=")[1] ? contentDisposition.split("filename=")[1].replace(/"/g, "") : '';
    link.click();
    return file;
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const downloadProjectInvoice = async (id, format, tempId) => {
  return await axios('get', PROJECT_INVOICE_DOWNLOAD, {}, {
    loader: loaders.OVERLAY, server: microServices.DE_CORE,
    params: {
      ...(id ? { id } : {}),
      ...(tempId ? { tempId } : {}),
      ...(format ? { format } : {}),
    },
    responseType: 'blob'
  }).then(({ file, headers = {} }) => {
    const url = window.URL.createObjectURL(new Blob([file]));
    const link = document.createElement('a');
    link.href = url;
    const contentDisposition = headers["content-disposition"];
    link.download = contentDisposition && contentDisposition.split("filename=")[1] ? contentDisposition.split("filename=")[1].replace(/"/g, "") : '';
    link.click();
    return file;
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getInvoiceAndProgressClaimList = async (query) => {
  return await axios('get', `${GET_Invoice_AND_PROGRESS_CLAIM_LIST}${query ? query : ''}`, {}, { server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const deleteProgressClaim = async (id, type) => {
  return await axios('delete', `${PROGRESS_CLAIM}/${id}/${type}`, {}, { successMessage: 'Progress Claim Deleted Successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getProjectCustomer = async (id) => {
  return await axios('get', `${GET_PROJECT_CUSTOMER}?id=${id}`, {}, { server: microServices.DE_CORE }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const revertToDraftProgressClaim = async (id) => {
  return await axios('put', `${PROGRESS_CLAIM}/${id}/revert-to-draft`, {}, { successMessage: 'Progress Claim reverted to draft successfully', server: microServices.DE_CORE }).then(data => {
    return data
  },
  error => { // request level error
    return new Promise((resolve, reject) => {
      reject(error)
    })
  })
}
export const getRetentionList = async (params = {}) => {
  return await axios('get', RETENTION_LIST, {}, { server: microServices.DE_CORE, params }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export const getTenantRetentionTotal = async (params = {}) => {
  return await axios('get', RETENTION_TOTAL, {}, { server: microServices.DE_CORE, params }).then(data => {
    return data
  },
    error => { // request level error
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })
}
